<template>


    <div class="row nmr-widget justify-content-center align-items-center">

        <div class="actions mb-3">
            <div class="custom">
                <button type="button" v-show="!showVideo" class="image-btn" @click="imageAction">
                    <img :src="`${directoryUrl}/img/video-bg.png`" />
                </button>
                <div v-if="showVideo" class="responsiveContent">
                    <div v-html="vimeoData.html" />
                </div>
            </div>
        </div>

        <a class="button-solid-rounded col-sm-12 col-lg-10 text-center mb-2" download target="_blank"
            :href="`${$store.state.clientConfig.directoryUrl}/documents/step-by-step-registration-guide.pdf`">
            Registration guide <span class="button-icon"><font-awesome-icon :icon="['fal', 'file-pdf']"></font-awesome-icon>
            </span>
        </a>

    </div>
</template>

<script>
import axios from 'axios';

export default {
    name: 'NMR-Homepage-Tile',
    data () {
        return {
            vimeoData: null,
            showVideo: false,
        };
    },
    computed: {
        directoryUrl () {
            return this.$store.state.clientConfig.directoryUrl;
        },
    },
    created () {
        this.initialise();
    },
    methods: {
        initialise () {
            let authSet = '';
            if (axios.defaults.headers.common.Authorization) {
                authSet = axios.defaults.headers.common.Authorization;
                axios.defaults.headers.common = {};
            }
            if (axios.defaults.headers.get.ImpersonateId) {
                axios.defaults.headers.get = {};
            }
            axios({
                method: 'get', // you can set what request you want to be
                url: 'https://vimeo.com/api/oembed.json?url=https://player.vimeo.com/video/1048910184&width=500',
                headers: {
                },
            })
                .then((response) => {
                    // handle success
                    this.vimeoData = response.data;
                });
            if (authSet !== '') {
                axios.defaults.headers.common.Authorization = authSet;
            }
        },

        imageAction () {
            this.showVideo = true;
            // log that the video was shown
            this.$store.dispatch('analytics/sendAnalyticsBeacon', {
                logType: 'videoLoaded',
                page: this.$route.fullPath,
                info: this.vimeoData.title,
            });
        },


        downloadGuide () {
            window.open(
                'https://teslawebclientconfig.blob.core.windows.net/sites/nmrpensionfundqa.lcptest.co.uk/documents/step-by-step-registration-guide.pdf',
                '_blank',
            );
        },
    },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/_mixins.scss';

.homepage-card {
    flex: 0 0 30%;
    box-sizing: border-box;

    &:not(:last-of-type) {
        padding-right: 1rem;
    }

    &--inner {
        position: relative;
        display: flex;
        flex-direction: column;
        padding: 1rem;
        height: 100%;
        background-color: white;
        border-radius: 0.5rem;

        .card-icon {
            position: absolute;
            bottom: 20px;
            right: 5px;
            /* font-size: 6rem; */
            opacity: 0.05;
            width: 100px;
        }

        .text-content {
            flex-grow: 1;

            h2 {
                font-size: 1.5rem;
                margin-bottom: 1rem;
            }
        }
    }
}

.custom {
    height: 100%;


    .image-btn {
        height: 100%;
        border: none;
        background-color: transparent;

        img {
            width: 100%;
            height: 100%;
            object-fit: fill;
        }
    }

    .responsiveContent {
        position: relative;
        overflow: hidden;
        padding-top: 56.25%;

        ::v-deep iframe {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            border: 0;
        }
    }
}

.nmr-widget {


    .actions {
        width: 100%;

        .icon {
            font-size: 30px;
            margin-right: 20px;
        }

        span {
            display: block;
            font-weight: normal;
        }

        .text {
            font-weight: bold;
        }

    }

}
</style>
